import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import ShareUrlsOptionsStore from '../DeepLinksOptionsStore';
import { SearchParameter, SearchParameters } from '../../../../../../ListFilter/Types';
import State from './State';

interface Props {
  duplicateProgramDeepLinkCount: number;
  optionsStore: ShareUrlsOptionsStore;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  actionButtons?: ReactNode;
}

function Filters({
  duplicateProgramDeepLinkCount,
  optionsStore,
  searchParameters,
  updatingSearchParameters,
  actionButtons,
}: Props) {
  return (
    <div
      className="max-w-clientPortalMaxWidth mx-auto px-2.5 lg:px-12 my-4"
      data-intercom-target="shareable-links-filters"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <State
            duplicateProgramDeepLinkCount={duplicateProgramDeepLinkCount}
            optionsStore={optionsStore}
            searchParameters={searchParameters}
            updatingSearchParameters={updatingSearchParameters}
          />
        </div>
        {actionButtons && <div className="flex items-center gap-3">{actionButtons}</div>}
      </div>
    </div>
  );
}
export default observer(Filters);
